<template>
  <div class="category-list" v-if="isLoaded && isVisible">
    <h3 class="category-list-hd" v-band-title tabindex="0">{{bandTitle}}</h3>
    <cell-list-category :cell-list="cellListFormat"></cell-list-category>
    <template v-if="cellList.length > 8">
      <button v-if="isMoreViewToggle" @click="viewMoreClick()" type="button" class="category-button-more">
        <span>더보기</span>
        <open-icon />
      </button>
      <button v-if="!isMoreViewToggle" @click="viewMoreClick()" type="button" class="category-button-more">
        <span>숨기기</span>
        <close-icon />
      </button>
    </template>
  </div>
</template>
<script>
import { get } from 'lodash'
import { bandTitle } from '@/common/directives'
import EventModelClass from '@/common/model/EventModelClass'
import { mapActions } from 'vuex'
import { FETCH_BAND_INFO } from '@/store/types/actions.type'
import OpenIcon from '@/assets/svg/common/ic_open_w.svg'
import CloseIcon from '@/assets/svg/common/ic-closd-w.svg'

import CellListCategory from '@/components/section/template/cell/CellListCategory'
export default {
  name: 'TemplateCategory',
  props: {
    sectionInfo: {
      type: Object
    }
  },
  components: {
    CellListCategory,
    OpenIcon,
    CloseIcon
  },
  directives: { bandTitle },
  data () {
    return {
      cellList: [],
      genTime: '',
      isLoaded: false,
      isVisible: true,
      isMoreViewToggle: false
    }
  },
  computed: {
    bandTitle () {
      return get(this.sectionInfo, 'title', '')
    },
    cellListFormat () {
      if (this.isMoreViewToggle) {
        return this.cellList.slice(0, 8)
      } else {
        return this.cellList
      }
    }
  },
  methods: {
    ...mapActions({ fetchBandData: FETCH_BAND_INFO }),
    setData () {
      this.fetchBandData(
        { eventModel: new EventModelClass(get(this.sectionInfo, 'contentEvent', {})),
          force: get(this.sectionInfo, 'forceRefresh', false) })
        .then((response) => {
          if (this.genTime !== get(response, 'genTime', '') || get(response, 'genTime', '') === null) {
            this.cellList = get(response, 'cellList', [])
            this.isMoreViewToggle = this.cellList.length > 8
            if (this.cellList.length === 0) this.isVisible = false
          }
          this.isLoaded = true
        })
    },
    viewMoreClick () {
      this.isMoreViewToggle = !this.isMoreViewToggle
    }
  },
  created () {
    this.setData()
  }
}
</script>
